//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['menuFeatured']),
    blok() {
      return this.menuFeatured
    },
    showSmartLink() {
      return this.blok.button && this.blok.button.length > 0
    },
  },
}
